import { useMemo } from 'react';

import VisitSettlement from '../visitSettlement';

import { VisitHistoryInfiniteList } from './VisitHistoryInfiniteList';
import { VisitHistoryInfiniteListLoader } from './VisitHistoryInfiniteListLoader';
import { VisitHistoryShowAnnulledCheckbox } from './VisitHistoryShowAnnulledCheckbox/VisitHistoryShowAnnulledCheckbox';

type VisitsHistoryPanel = {
   AnnulledVisitsPreferenceVisibilityCheckbox: () => JSX.Element;
   VisitsHistoryInfiniteList: (props: { patientId: number }) => JSX.Element;
};

export const useVisitsHistoryPanel = (): VisitsHistoryPanel => {
   return useMemo(
      () => ({
         VisitsHistoryInfiniteList: (props: { readonly patientId: number }): JSX.Element => (
            <VisitHistoryInfiniteListLoader patientId={props.patientId}>
               {({ visitHistoryPages, fetchNextVisitHistoryPage, nextVisitHistoryPageAvailable }) => {
                  const partialAppointmentIds = visitHistoryPages.at(-1)!.map(({ appointmentId }) => appointmentId);
                  return (
                     <>
                        <VisitSettlement.MedicalServicesCounterResolver appointmentIds={partialAppointmentIds} />
                        <VisitHistoryInfiniteList
                           patientId={props.patientId}
                           data={visitHistoryPages}
                           onLoadMore={fetchNextVisitHistoryPage}
                           loadMoreAvailable={nextVisitHistoryPageAvailable}
                        />
                     </>
                  );
               }}
            </VisitHistoryInfiniteListLoader>
         ),
         AnnulledVisitsPreferenceVisibilityCheckbox: VisitHistoryShowAnnulledCheckbox,
      }),
      []
   );
};
